import { useEffect, useState } from "react";
import { getDaysInMonth, startOfDay, startOfMonth } from "date-fns";
import { numArrayOfLength } from "./util";

export const useDatePickerState = (
  onChange: (date: Date) => void,
  initialDate?: Date,
  value?: Date | null,
) => {
  const initial = startOfDay(new Date(value || initialDate || Date.now()));
  const [date, setInternalDate] = useState(initial);
  const [currentMonth, setCurrentMonth] = useState(date.getMonth());
  const [currentYear, setCurrentYear] = useState(date.getFullYear());
  const selectedTimestamp = value?.getTime();
  const controlled = value !== undefined;
  useEffect(() => {
    if (!controlled) return;
    const selected = startOfDay(new Date(selectedTimestamp ?? Date.now()));
    setInternalDate(selected);
    setCurrentMonth(selected.getMonth());
    setCurrentYear(selected.getFullYear());
    // A fresh Date object for the same selection must not reset month browsing.
  }, [selectedTimestamp, controlled]);

  const nextMonth = () => {
    const date = new Date(currentYear, currentMonth + 1);
    if (date.getFullYear() !== currentYear) {
      setCurrentYear(date.getFullYear());
    }
    setCurrentMonth(date.getMonth());
  };
  const previousMonth = () => {
    const date = new Date(currentYear, currentMonth - 1);
    if (date.getFullYear() !== currentYear) {
      setCurrentYear(date.getFullYear());
    }
    setCurrentMonth(date.getMonth());
  };

  const setDate = (d: number) => {
    const selected = new Date(currentYear, currentMonth, d);
    setInternalDate(selected);
    onChange(selected);
  };

  const displayedMonth = new Date(currentYear, currentMonth, 1);
  const daysInMonth = numArrayOfLength(getDaysInMonth(displayedMonth));
  const startOfMonthIndex = startOfMonth(displayedMonth).getDay();
  const emptyDays = numArrayOfLength(startOfMonthIndex); // the blank cells at the start of the month
  const daysOfMonth = [...emptyDays.map(() => undefined), ...daysInMonth];

  return {
    nextMonth,
    previousMonth,
    setDate,
    daysOfMonth,
    displayedMonth,
    date,
  };
};
